import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { FunctionComponent } from "react";
import { AlertDialogHeader, AlertDialogFooter } from "./ui/alert-dialog";

interface DeleteAlertProps {
  title: string;
  description: string;
  confirmText?: string;
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

const DeleteAlert: FunctionComponent<DeleteAlertProps> = ({
  title,
  description,
  confirmText = "Delete",
  open,
  onCancel,
  onDelete,
}) => {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onCancel();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction variant={"destructive"} onClick={onDelete}>
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteAlert;
